import { Station, StationRawData } from "@shared/models";
import { convertDateToTimezone, getCurrentTimezone } from "@shared/utils";

export const combineStationValues = (station: Station) => {
  const currentUserTimezone = getCurrentTimezone();

  return (values: { rows: StationRawData[]; station_id: number }[]) => {
    const items = values.reduce((res: StationRawData[], item: { rows: StationRawData[]; station_id: number }) => {
      return [...res, ...item.rows.map((row: StationRawData) => ({ ...row, station_id: station.id }))];
    }, []);

    const groupedItems = items.reduce((res: any, item: StationRawData) => {
      const key = `${convertDateToTimezone(item.time, station.timezone || currentUserTimezone)?.toLocaleTimeString()}(${
        item.part
      })`;

      const originalTime = convertDateToTimezone(
        item.original_time,
        station.timezone || currentUserTimezone,
      )?.toLocaleTimeString();

      res[key] = res[key] || {
        row_number: {},
        time: key,
        original_time: originalTime,
        original_seconds: item.original_seconds,
        seconds: item.seconds,
        raw_value: item.raw_value,
        tuning: item.tuning,
        tuning_reset: item.tuning_reset,
        station_code: item.station_id,
        dots: [],
      };

      res[key][String(item.station_id)] = item.value;
      res[key].row_number[String(item.station_id)] = item.row_number;

      return res;
    }, {});

    return (Object.values(groupedItems) as StationRawData[]).sort((a, b) => a.seconds - b.seconds);
  };
};
